const DEFAULT_HEIGHT = 0.05;

import { WAVEFORM_SAMPLES } from '../../../../../constants';

export const generateMinimalPeaks = (
  length = WAVEFORM_SAMPLES,
  heightValue?: number
) => {
  const minHeight = heightValue ?? DEFAULT_HEIGHT;

  return [new Float32Array(Array(length).fill(minHeight))];
};
